<template>
  <v-card>
    <v-navigation-drawer v-model="drawer" app>
      <!--  -->

      <v-list>
        <v-list-item v-on:click.prevent="scrollToSection('home')">
          <v-list-item-title> Home </v-list-item-title>
        </v-list-item>

        <v-list-item v-on:click.prevent="scrollToSection('about')">
          <v-list-item-title> About </v-list-item-title>
        </v-list-item>

        <v-list-item v-on:click.prevent="scrollToSection('faq')">
          <v-list-item-title> FAQ </v-list-item-title>
        </v-list-item>

        <v-list-item v-on:click.prevent="scrollToSection('contact')">
          <v-list-item-title> Contact </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      color="#005b4e"
      shrink-on-scroll
      prominent
      dark
      scroll-target="#scrolling-techniques-4"
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-img
        :src="'/imgs/logo_BSR_with_Cynthia_ white_on_green.png'"
        max-height="128"
        max-width="200"
        contain
      ></v-img>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-tabs align-with-title background-color="transparent">
          <v-tab v-on:click.prevent="scrollToSection('home')">Home</v-tab>
          <v-tab v-on:click.prevent="scrollToSection('about')">About</v-tab>
          <v-tab v-on:click.prevent="scrollToSection('faq')">FAQ</v-tab>
          <v-tab v-on:click.prevent="scrollToSection('contact')">Contact</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row id="home" style="z-index: 1">
          <v-col cols="12" md="12">
            <v-carousel cycle ref="carousel">
              <v-carousel-item
                v-for="(item, i) in carouselPics"
                :key="i"
                :src="item.src"
                reverse-transition="fade-transition"
                transition="fade-transition"
                aspect-ratio="1.5"
                class="absolute fill-height"
              >
              </v-carousel-item>

              <div class="button-container">
                <v-btn
                  v-on:click.prevent="scrollToSection('contact')"
                  class="carousel-btn mx-4"
                  outlined
                  color="teal"
                  x-large
                  rounded
                  elevation="11"
                  >Contact
                </v-btn>
                <v-btn
                  v-on:click.prevent="scrollToSection('about')"
                  class="carousel-btn mx-4"
                  outlined
                  color="teal"
                  x-large
                  rounded
                  elevation="11"
                  >&nbsp;&nbsp; About&nbsp;&nbsp;
                </v-btn>
              </div>
            </v-carousel>
          </v-col>
        </v-row>
      </v-container>

      <v-container >
        <v-row align="center" justify="center">
          <v-col cols="10" sm="3">
            <v-img
              :src="'/imgs/bsr-cynthia-green-on-white.png'"
              max-height="428"
              max-width="200"
              contain
            ></v-img>
          </v-col>
        </v-row>
      </v-container>

      <v-container >
        <v-row cols="12" md="6">
          <v-col>
            <h1 class="text-center mb-4 pb-2 border-bottom">
              Welcome to Cynthia's Body Stress Release Website
            </h1>
          </v-col>
        </v-row>
      </v-container>

      <v-container >
        <v-row id="about" class="py-10">
          <v-col cols="12" md="6">
            <div class="image-container">
              <v-img
                src="/imgs/pexels-brandon-imbriale-10935236.jpg"
                max-width="400"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <h2>About Body Stress Release</h2>
            <p>
              Body Stress Release (BSR) is a complementary health technique that
              aims to identify and release stored tension in the body. It was
              developed in South Africa in the 1980s by Gail and Ewald
              Meggersee.
            </p>
            <p>
              BSR practitioners use a series of gentle and non-invasive
              techniques to identify areas of the body where stress is stored.
              They apply light pressure or gentle tapping to these areas to help
              the body release the tension and restore its natural balance. BSR
              is based on the idea that stress can cause the muscles to
              contract, leading to pain and other symptoms.
            </p>
            <p>
              BSR is often used to address a range of physical and emotional
              conditions, including back pain, headaches, fatigue, and anxiety.
              It is considered safe and can be used alongside conventional
              medical treatments.
            </p>
            <p>
              For more information, please visit

              <v-btn
                outlined
                href="https://bodystressrelease.com/"
                target="_blank"
              >
                bodystressrelease.com
              </v-btn>
            </p>
          </v-col>
        </v-row>
      </v-container>

      <v-container id="faq">
        <v-row>
          <v-col>
            <h1 class="text-center mb-4 pb-2 border-bottom">
              Frequently Asked Questions
            </h1>
          </v-col>
        </v-row>

        <v-row class="py-10">
          <v-col>
            <v-expansion-panels>
              <v-expansion-panel v-for="(item, index) in faqItems" :key="index">
                <v-expansion-panel-header>{{
                  item.question
                }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p>{{ item.answer }}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="person-container" >
        <v-row>
          <v-col>
            <h1 class="text-center mb-4 pb-2 border-bottom">Cynthia</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="person-info">
              <p class="person-description">
                Cynthia has always been passionate about anything related to the
                human body. As a former swimmer for her home country of
                Guatemala, she has always been interested in physical fitness
                and health. She later went on to become a qualified
                physiotherapist in her home country.
              </p>

              <p class="person-description">
                After experiencing severe back pain from a car accident, Cynthia
                tried various therapies each of which offered some relief but
                she continued to experience lingering pain in the affected area.
                It wasn't until she received sessions from a Body Stress Release
                (BSR) practitioner that this chronic pain was healed. BSR is a
                gentle and non-invasive technique that works to release stored
                tension in the body, allowing it to heal naturally.
              </p>

              <p class="person-description">
                Cynthia was so impressed with the results of BSR that she
                decided to become a practitioner herself. She trained in South
                Africa, where BSR was developed, and has begun to build up a
                client base in South Africa as well as her home country of
                Guatemala.
              </p>

              <p class="person-description">
                At BSR, we believe in the body's innate ability to heal itself.
                Our aim is to help our clients release tension and stress,
                promoting optimal health and wellbeing. Cynthia's passion for
                the body and her experience as a physiotherapist and BSR
                practitioner make her uniquely qualified to help clients achieve
                their health goals.
              </p>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-img
              :src="'/imgs/cynthia-cabra.jpg'"
              max-height="628"
              max-width="400"
              contain
            ></v-img>
          </v-col>
        </v-row>
      </v-container>

      <v-container id="contact" class="contact-container" >
        <v-row>
          <v-col>
            <h1 class="text-center mb-4 pb-2 border-bottom">Contact Us</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="contact-info">
              <v-icon class="mdi mdi-phone"></v-icon>
              <span class="info-text">078 196 1114</span>
            </div>
            <!-- <div class="contact-info">
              <v-icon class="mdi mdi-email"></v-icon>
              <span class="info-text">bsrcynthia@gmail.com</span>
            </div> -->
            <div class="contact-info">
              <v-icon class="mdi mdi-map-marker"></v-icon>
              <span class="info-text"
                >200 Carinus Street, Meyerspark, Pretoria</span
              >
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="social-media">
              <v-btn class="facebook" icon>
                <v-icon class="mdi mdi-facebook"></v-icon>
              </v-btn>
              <v-btn class="instagram" icon>
                <v-icon class="mdi mdi-instagram"></v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
<v-card flat class="mb-6">
  <v-card-text class="pa-0 text-center">
    <iframe
      width="100%"
      height="380"
      frameborder="0"
      style="border:0; max-width: 100%; display: block; margin: 0 auto;"
      referrerpolicy="no-referrer-when-downgrade"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.847890584146!2d28.310471877816884!3d-25.742543345336035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e955fcfbdcf237d%3A0xf234b0da21995800!2s200%20Carinus%20St%2C%20Meyerspark%2C%20Pretoria%2C%200103!5e0!3m2!1sen!2sza!4v1770989606063!5m2!1sen!2sza"
      allowfullscreen
      loading="lazy"
    ></iframe>
  </v-card-text>
</v-card>

      </v-container>
    </v-main>
  </v-card>
</template>

<script>
export default {
  name: "playground",
  data: () => ({
    drawer: false,
    //
    //
    carouselPics: [
      {
        src: "/imgs/leafy_feet.jpg",
      },
      {
        src: "/imgs/stones-stephane-yaich.jpg",
      },
      {
        src: "/imgs/c-waterfall-crop.jpg",
      },
      {
        src: "/imgs/stacked-stones.jpg",
      },
    ],

    //
    faqItems: [
      {
        question: "What is Body Stress Release?",
        answer:
          "Body Stress Release (BSR) is a complementary health technique that aims to identify and release stored tension in the body. It involves gentle and non-invasive techniques to help the body release tension and restore its natural balance.",
      },
      {
        question: "How does Body Stress Release work?",
        answer:
          "BSR works by identifying areas of the body where stress is stored and applying gentle pressure or tapping to these areas to help the body release the tension. This can help to alleviate pain, discomfort, and other symptoms associated with stress.",
      },
      {
        question: "What are the benefits of Body Stress Release?",
        answer:
          "The benefits of BSR may include relief from back pain, headaches, fatigue, anxiety, and other physical and emotional conditions. BSR can also help to improve overall health and well-being by reducing stress and tension in the body.",
      },
      {
        question: "Is Body Stress Release safe?",
        answer:
          "BSR is generally considered safe and non-invasive. However, it is important to note that BSR is not a substitute for medical advice or treatment, and individuals should consult with a healthcare professional before trying any new complementary therapy.",
      },
      {
        question: "How long does a Body Stress Release session take?",
        answer:
          "A typical BSR session takes around 30-45 minutes. During the session, the practitioner will assess the body for areas of tension and apply gentle techniques to help release the stress.",
      },
      {
        question: "How many Body Stress Release sessions are needed?",
        answer:
          "The number of BSR sessions needed may vary depending on the individual and their specific needs. Some people may experience relief after just one session, while others may require multiple sessions to achieve optimal results.",
      },
      {
        question: "What should I expect during a Body Stress Release session?",
        answer:
          "During a BSR session, the practitioner will ask you about your medical history and any current symptoms you are experiencing. They will then assess your body for areas of tension and apply gentle techniques to help release the stress. You may feel some mild discomfort or sensations during the session, but it should not be painful.",
      },
      {
        question: "Is Body Stress Release covered by insurance?",
        answer:
          "The coverage for BSR by insurance varies depending on the policy and the insurance provider. It is recommended that you check with your insurance provider to determine if BSR is covered under your plan.",
      },
    ],
  }),

  methods: {
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      section.scrollIntoView({ behavior: "smooth" });
    },

    startAutoScroll() {
      // start auto-scrolling every 5 seconds
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.carouselPics.length;
      }, 5000);
    },
    stopAutoScroll() {
      // stop auto-scrolling
      clearInterval(this.timer);
    },
  },
};
</script>

<style scoped>


/**

    Section headings styling
   */

.text-center {
  text-align: center;
}
.mb-4 {
  margin-bottom: 1rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.border-bottom {
  border-bottom: 1px solid #333;
}

.image-container {
  max-width: 400px;
}

.no-top-padding {
  padding-top: 0 !important;
}

.carousel-btn {
  background-color: white;
}

.carousel-btn:hover {
  background-color: darkgray;
  color: white;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  /* top is whawt positions these from halwy from top*/
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
}

/* .v-main {
  top: 224px;
}
 */

/**

    Section headings styling
   */

.contact-container {
  background-color: #f5f5f5;
  padding: 2rem;
}
.contact-info {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.contact-info .mdi {
  margin-right: 1rem;
  font-size: 1.5rem;
}
.info-text {
  font-size: 1rem;
}
.social-media {
  display: flex;
  justify-content: center;
}
.facebook {
  background-color: #3b5998;
}
.instagram {
  background-color: #c13584;
  margin-left: 1rem;
}
</style>